import { HubspotFieldEditorProps } from "@v2/components/controls/editors/types";
import { DataField } from "shared/providers/types";
import React from "react";
import { DateValue, SelectorValue, SimpleValue } from "src/components/Flowsteps/base/FilterManager";
import { isSubstitutionPattern } from "shared/utils/querySubstitution";

export type FieldControlProps = HubspotFieldEditorProps & {
  operator?: string;
  field?: DataField;
}

export const DefaultEditor: React.FC<FieldControlProps & { disableMultiply?: boolean }> = ({ value, onChange, disableMultiply }) => {
  const hasMultipleValues = !disableMultiply && value?.includes(',');
  return (
    <SimpleValue
      value={value}
      onChange={onChange}
      plural={hasMultipleValues}
    />
  )
}

export const DateTimeEditor: React.FC<FieldControlProps> = ({ value, onChange }) => {
  const isSubstitution = isSubstitutionPattern(value);
  return (
    <DateValue
      value={value}
      onChange={onChange}
      fieldType={'datetime'}
      isSubstitution={isSubstitution} />
  );
};
